import { getGoogleMeasurementConsent } from "@seamapi/shared/google-measurement-consent"

const denied = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
} as const
let previousConsent: string | undefined
const none = { analytics: false, advertising: false }

export const synchronizeGoogleConsent = () => {
  let allowed = none
  try {
    allowed = getGoogleMeasurementConsent()
  } catch {
    // An inaccessible consent record cannot enable measurement.
  }
  if (typeof window === "undefined") return none
  try {
    if (!window.gtag && !allowed.analytics && !allowed.advertising) return none
    if (!window.gtag) {
      const queue = (window.dataLayer ??= [])
      window.gtag = function (..._args: unknown[]) {
        // Google consumes Arguments objects, matching its documented snippet.
        // eslint-disable-next-line prefer-rest-params
        queue.push(arguments)
      }
      window.gtag("consent", "default", denied)
      previousConsent = "false:false"
    }
    const key = `${allowed.analytics}:${allowed.advertising}`
    if (previousConsent !== key) {
      // Account/auth routes can contain email or bearer tokens in URL metadata.
      window.gtag("set", {
        page_location: "https://console.seam.co/",
        page_referrer: "",
        page_title: "Seam Console",
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
      })
      window.gtag("consent", "update", {
        ad_storage: allowed.advertising ? "granted" : "denied",
        // Without ad_user_data, Google drops the click ID (gclaw) and auid from
        // the signup conversion, so it cannot be attributed to the ad click.
        // Advertising consent already excludes GPC. Never enables remarketing.
        ad_user_data: allowed.advertising ? "granted" : "denied",
        ad_personalization: "denied",
        analytics_storage: allowed.analytics ? "granted" : "denied",
      })
      previousConsent = key
    }
    return allowed
  } catch {
    return none
  }
}
